import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, Output, EventEmitter, signal, computed } from "@angular/core";
import { AppService } from "@root/app.service";
import { PlatformType } from "@root/config";
import { TranslateService } from "@root/shared/service/translate.service";
import { pick } from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { PropertyDetailService } from "../../property-detail.service";
import { filter } from "rxjs";

interface PriceItem {
  origin_house_id: any;
  title: string;
  thirdparty_type: number;
  daily_price: number;
  weekend_price: number;
}

@Component({
  selector: "property-detail-pricing",
  templateUrl: "./pricing.component.html",
  styleUrls: ["./pricing.component.scss"],
})
export class PricingComponent implements OnInit {
  private readonly SaveApi = "/api/calendar/edit_basic_price";
  private readonly HouseListApi = "/api/house/bind_platform";
  readonly DailyPriceUnsupportedChannels = [
    PlatformType.Booking,
    PlatformType.Ctrip,
    PlatformType.Fliggy,
    PlatformType.Vrbo,
    PlatformType.Agoda,
    PlatformType.MeiTuanJiuDian,
  ];
  readonly WeekendPriceUnsupportedChannels = [
    PlatformType.XiaoZhu,
    PlatformType.MuNiao,
    ...this.DailyPriceUnsupportedChannels,
  ];
  @Input() prices: PriceItem[] = [];
  @Input() houseId;
  @Input() originHouseId;
  @Output() onNavigate = new EventEmitter();
  batchDailyPrice;
  batchWeekendPrice;

  //#region Listing Specific Settings
  listOfHouse = [];
  listOfHouseSupportSetRules = [];
  total = 0;
  page = 1;
  pageSize = 20;
  currentHouse;
  showBookingSettings = false;
  //#endregion

  //#region Show More

  showMoreItem = signal(false);
  readonly showMoreItemLimit = 2;
  showMoreText = computed(() => {
    return this.showMoreItem()
      ? this.t.t("property-property_detail-pricing-ratio_html_spo_less")
      : this.t.t("property-property_detail-pricing-ratio_html_spo_more", {
          number: this.prices.length - this.showMoreItemLimit,
        });
  });
  //#endregion
  get isInternational() {
    return this.app.app.international;
  }
  constructor(
    private pdSrv: PropertyDetailService,
    private http: HttpClient,
    private msg: NzMessageService,
    private app: AppService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchBindedHouseList();

    this.pdSrv.pageDataChange$.pipe(filter((data) => data?.page === "rules")).subscribe(({ data }) => {
      Object.assign(this, data);
    });
  }

  isSupportPrice(type: "daily_price" | "weekend_price", channel) {
    if (type === "daily_price") {
      return this.isSupportDailyPrice(channel);
    } else {
      return this.isSupportWeekendPrice(channel);
    }
  }

  isSupportDailyPrice(channel) {
    return this.DailyPriceUnsupportedChannels.indexOf(channel) === -1;
  }

  isSupportWeekendPrice(channel) {
    return this.WeekendPriceUnsupportedChannels.indexOf(channel) === -1;
  }

  isSupportSetRules(channel) {
    return channel === PlatformType.Vrbo || channel === PlatformType.Airbnb;
  }

  onBatchDailyPriceChange() {
    this.prices.forEach((price) => {
      price.daily_price = this.batchDailyPrice;
    });
  }

  onBatchWeekendPriceChange() {
    this.prices.forEach((price) => {
      price.weekend_price = this.batchWeekendPrice;
    });
  }

  onSave() {
    this.requestSave();
  }

  onClickHouse(house) {
    if (!this.isSupportSetRules(house.thirdparty_type)) {
      return;
    }
    this.showBookingSettings = true;
    this.currentHouse = house;
    console.log("currenHouse: ", this.currentHouse);
    this.onNavigate.emit();
  }

  onPageChange() {}

  private fetchBindedHouseList() {
    const params = { house_id: this.houseId };
    this.http.get(this.HouseListApi, { params }).subscribe((rst: any) => {
      this.listOfHouse = rst?.data?.list;

      this.listOfHouseSupportSetRules = this.listOfHouse?.filter((house) =>
        this.isSupportSetRules(house.thirdparty_type),
      );
      console.log("list of support set rules: ", this.listOfHouseSupportSetRules);
      console.log("originHouseId: ", this.originHouseId);
      if (this.originHouseId) {
        const house = this.listOfHouseSupportSetRules.find((item) => item.origin_house_id === this.originHouseId);
        this.onClickHouse(house);
      }
    });
  }

  private requestSave() {
    const prices = this.prices.map((item) => ({
      ...pick(item, ["daily_price", "weekend_price", "thirdparty_type", "origin_house_id"]),
    }));
    const params = {
      type: 0,
      basic_prices_list: JSON.stringify(prices),
    };
    this.http.post(this.SaveApi, params).subscribe((rst: any) => {
      if (rst?.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }
}
